export default __webpack_public_path__ + "static/media/pencil-waitlist.8415fbd6.svg";